import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { SolicitacaoExame } from 'graphql/types.generated'
import { LotacaoFolhaRosto } from 'view/atendimentos/detail/folha-rosto/model'
import { LotacaoAtendimento } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { SolicitacaoExameQueryModel } from '../../objetivo/resultados-exames/model-resultadosExames'
import { showCodigoProcedimentoRef } from '../../objetivo/resultados-exames/util-resultadosExames'
import {
  ImpressaoSolicitacaoExamesInput,
  ItemHistoricoSolicitacaoExameModel,
  SolicitacaoExameMergedModel,
  SolicitacaoExameModel,
} from './model-solicitacaoExames'

export const convertSolicitacaoFromQueryToSolicitacaoWithInfo = (
  solicitacoesExame: SolicitacaoExameQueryModel[]
): ItemHistoricoSolicitacaoExameModel[] => {
  return !!solicitacoesExame
    ? solicitacoesExame.map((solicitacao: SolicitacaoExame) => {
        const mapSolicitacao = solicitacao.exames
          .map((exame) => `${showCodigoProcedimentoRef(exame.exame, true)}`.capitalize())
          .join(' | ')

        return {
          id: solicitacao.id,
          solicitacao: {
            examesSolicitados: solicitacao.exames,
            justificativa: solicitacao.justificativa,
            tipoExame: solicitacao.tipoExame,
            cid10: solicitacao.cid10 as CidSelectFieldModel,
            observacao: solicitacao.observacoes,
          } as SolicitacaoExameMergedModel,
          data: solicitacao.data,
          atendimentoProfissionalId: solicitacao.atendimentoProfissional.id,
          lotacao: solicitacao.atendimentoProfissional.lotacao,
          adicionadoAgora: false,
          title: mapSolicitacao,
          codigos: solicitacao.exames.map((exame) => exame.exame.codigo).join(' '),
        }
      })
    : []
}

export const convertSolicitacaoFromAtendToSolicitacaoWithInfo = (
  solicitacoesExame: SolicitacaoExameModel[],
  {
    dataReferencia,
    atendimentoProfissionalId,
    lotacao,
  }: { dataReferencia: Instant; atendimentoProfissionalId: ID; lotacao: LotacaoAtendimento | LotacaoFolhaRosto }
): ItemHistoricoSolicitacaoExameModel[] => {
  return !!solicitacoesExame
    ? solicitacoesExame.map((solicitacao: SolicitacaoExameModel) => {
        return {
          id: solicitacao._id,
          editingId: solicitacao.editingId,
          solicitacao: {
            ...solicitacao,
            examesSolicitados: solicitacao.examesSolicitados.map((exameSolicitado) => {
              return {
                ...exameSolicitado,
                id: exameSolicitado._id,
                conferido: false,
              }
            }),
          },
          atendimentoProfissionalId,
          lotacao,
          data: dataReferencia,
          adicionadoAgora: true,
          title: solicitacao.examesSolicitados
            .map((exame) => `${showCodigoProcedimentoRef(exame.exame, true)}`.capitalize())
            .join(' | '),
          codigos: solicitacao.examesSolicitados.map((exame) => exame.exame.codigo).join(' '),
        }
      })
    : []
}

export const convertHistoricoSolicitacaoExameToImpressao = (
  items: ItemHistoricoSolicitacaoExameModel[],
  prontuarioId: ID,
  atendimentoId: ID,
  cidadaoId: ID
): ImpressaoSolicitacaoExamesInput[] => {
  return items
    ? items.map((row) => ({
        id: row.adicionadoAgora ? null : row.id,
        prontuarioId: prontuarioId,
        atendimentoId: atendimentoId,
        solicitacao: row.adicionadoAgora
          ? {
              examesRequisitados: row.solicitacao.examesSolicitados.map((item) => ({
                idExame: item.exame.id,
                observacoes: item.observacao,
              })),
              observacoes: row.solicitacao?.observacao,
              tipoExame: row.solicitacao.tipoExame,
              cid10: row.solicitacao.cid10?.id,
              justificativa: row.solicitacao?.justificativa,
            }
          : null,
        idCidadao: cidadaoId,
        idAtendimentoProfissional: row.atendimentoProfissionalId,
      }))
    : []
}
